// import React from "react";

// const Footer = () => {
//   const customerService = [
//     "Help Center",
//     "Report abuse",
//     "File a case",
//     "Policies & rules",
//     "Get paid for your feedback",
//   ];

//   const aboutUs = ["About Naayatrade", "Naayatrade Blog"];

//   const source = [
//     "Resources",
//     "All categories",
//     "Request for Quotation",
//     "Ready to Ship",
//     "Byuer partners",
//   ];

//   const sellOnNaaya = [
//     "Supplier memberships",
//     "Learning Center",
//     "Partner Program",
//   ];

//   const tradeServices = [
//     "Trade Assurance",
//     "Business identity",
//     "Logistics servies",
//     "Production Monitoring & Inspection",
//     "Services",
//     "Letter of Credit",
//   ];

//   // const socialIcons = [
//   //   require("../../../assets/homepage/footer/socialIcons/facebook.png"),
//   //   require("../../../assets/homepage/footer/socialIcons/instagram.png"),
//   //   require("../../../assets/homepage/footer/socialIcons/linkedin.png"),
//   //   require("../../../assets/homepage/footer/socialIcons/youtube.png"),
//   //   require("../../../assets/homepage/footer/socialIcons/twitter.png"),
//   // ];

//   const socialIcons = [
//     {
//       url: "https://www.facebook.com/people/Naayatrade/61550488497068/?mibextid=ZbWKwL",
//       imgSrc: require("../../../assets/homepage/footer/socialIcons/facebook.png"),
//       alt: "Facebook",
//     },
//     {
//       url: "https://www.instagram.com/NAAYATRADE/",
//       imgSrc: require("../../../assets/homepage/footer/socialIcons/instagram.png"),
//       alt: "Instagram",
//     },
//     {
//       url: "https://www.linkedin.com/company/naaya-business-venture-pvt-ltd/mycompany/",
//       imgSrc: require("../../../assets/homepage/footer/socialIcons/linkedin.png"),
//       alt: "LinkedIn",
//     },
//     {
//       url: "https://www.youtube.com/channel/UCCnjN2CmQdGVFFzwCdE7XiQ",
//       imgSrc: require("../../../assets/homepage/footer/socialIcons/youtube.png"),
//       alt: "YouTube",
//     },
//     {
//       url: "https://x.com/naayatrade?s=09",
//       imgSrc: require("../../../assets/homepage/footer/socialIcons/twitter.png"),
//       alt: "Twitter",
//     },
//   ];

//   return (
//     <div className="flex flex-col items-center bg-[#3A475B] text-white w-full h-[770px]">
//       <img
//         src={require("../../../assets/homepage/footer/naayaLogo.png")}
//         className="w-[202px] h-[71px] mt-[15px]"
//       />
//       <h2 className="w-[720px] h-[50px] text-[16px] font-medium select-none">
//         Trade Alert-Delivery the latest product trends and industry news
//         straight to your inbox.
//       </h2>
//       <div className="flex gap-x-6">
//         <input
//           placeholder="Your email"
//           className="bg-inherit border-2 w-[16rem] px-2 py-[6px]"
//         />
//         <button className="bg-[#FF6300] px-4 border-[1px] font-semibold">
//           Subscribe
//         </button>
//       </div>
//       <p className="mt-[15px] text-[11.5px] opacity-50 select-none">
//         We never share your email addres with a third-party
//       </p>
//       <div className="flex gap-x-[65px] mt-[20px] w-[1241px] h-[220px]">
//         <div className="flex flex-col items-start w-[210px]">
//           <h2 className="text-[18px] font-semibold select-none">
//             Customer services
//           </h2>
//           {customerService.map((item, index) => (
//             <div
//               key={index}
//               className="text-[14px] mt-2 cursor-pointer hover:text-[#FF6300]"
//             >
//               {item}
//             </div>
//           ))}
//         </div>
//         <div>
//           <div className="flex flex-col items-start w-[100px]">
//             <h2 className="text-[18px] font-semibold select-none">About Us</h2>
//             {aboutUs.map((item, index) => (
//               <div
//                 key={index}
//                 className="text-[14px] mt-2 cursor-pointer hover:text-[#FF6300]"
//               >
//                 {item}
//               </div>
//             ))}
//           </div>
//         </div>
//         <div>
//           <div className="flex flex-col items-start w-[210px]">
//             <h2 className="text-[18px] font-semibold select-none">
//               Source on Naayatrade
//             </h2>
//             {source.map((item, index) => (
//               <div
//                 key={index}
//                 className="text-[14px] mt-2 cursor-pointer hover:text-[#FF6300]"
//               >
//                 {item}
//               </div>
//             ))}
//           </div>
//         </div>
//         <div>
//           <div className="flex flex-col items-start w-[220px]">
//             <h2 className="text-[18px] font-semibold select-none">
//               Sell on naayatrade.com
//             </h2>
//             {sellOnNaaya.map((item, index) => (
//               <div
//                 key={index}
//                 className="text-white text-[14px] mt-2 cursor-pointer hover:text-[#FF6300]"
//               >
//                 {item}
//               </div>
//             ))}
//           </div>
//         </div>
//         <div>
//           <div className="flex flex-col items-start w-[250px]">
//             <h2 className="text-[18px] font-semibold select-none">
//               Trade services
//             </h2>
//             {tradeServices.map((item, index) => (
//               <div
//                 key={index}
//                 className="text-white text-[14px] mt-2 cursor-pointer hover:text-[#FF6300]"
//               >
//                 {item}
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//       <div className="w-[1241px] border-[1px] border-white my-4 opacity-15" />
//       <div className="w-[1235px] flex justify-between mt-[15px]">
//         <div className="flex items-center gap-x-2 select-none">
//           <h2>Download our app:</h2>
//           {/* <div className="flex pl-[10px] gap-x-2 w-[189px] h-[46px] cursor-pointer bg-[#A4C639] rounded-[5px]">
//             <div className=" ml-[12px] flex items-center justify-center">
//             <img
//               className="flex items-center justify-center mt-[2px]"
//               src={require("../../../assets/homepage/footer/footerLogo/apple.png")}
//               alt="IOS"
//             />
//             </div>
//             Available on the App Store
//           </div> */}
//           <div className="flex gap-x-[10px] cursor-pointer w-[197px] h-[46px] bg-[#999999] rounded-[5px] items-center justify-center">
//             <img
//               className="flex items-center justify-center w-[35px] h-[35px]"
//               src={require("../../../assets/homepage/footer/footerLogo/android.png")}
//               alt="Android"
//             />

//             <a
//               href="https://play.google.com/store/apps/details?id=com.naayatrade.naayatrade&pli=1"
//               target="_blank"
//               rel="noopener noreferrer"
//               className="w-[110px] h-[36px] font-semibold text-[16px] text-white text-start leading-[18px]"
//             >
//               Available on Google Play
//             </a>
//           </div>
//         </div>
//         <div className="flex items-center gap-x-2 select-none">
//           <h2>Follows:</h2>
//           {socialIcons.map((icon, index) => (
//             // <button>
//             //   <div key={index}>
//             //     <img src={item} className="h-[25px] w-[25px]" />
//             //   </div>
//             // </button>
//             <a
//               key={index}
//               href={icon.url}
//               target="_blank"
//               rel="noopener noreferrer"
//             >
//               <img
//                 src={icon.imgSrc}
//                 alt={icon.alt}
//                 className="h-[25px] w-[25px]"
//               />
//             </a>
//           ))}
//         </div>
//       </div>
//       <div className="flex gap-x-[5px] items-center justify-center mt-[35px]">
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           viewBox="0 0 24 24"
//           fill="currentColor"
//           class="w-6 h-6"
//         >
//           <path
//             fill-rule="evenodd"
//             d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25ZM6.262 6.072a8.25 8.25 0 1 0 10.562-.766 4.5 4.5 0 0 1-1.318 1.357L14.25 7.5l.165.33a.809.809 0 0 1-1.086 1.085l-.604-.302a1.125 1.125 0 0 0-1.298.21l-.132.131c-.439.44-.439 1.152 0 1.591l.296.296c.256.257.622.374.98.314l1.17-.195c.323-.054.654.036.905.245l1.33 1.108c.32.267.46.694.358 1.1a8.7 8.7 0 0 1-2.288 4.04l-.723.724a1.125 1.125 0 0 1-1.298.21l-.153-.076a1.125 1.125 0 0 1-.622-1.006v-1.089c0-.298-.119-.585-.33-.796l-1.347-1.347a1.125 1.125 0 0 1-.21-1.298L9.75 12l-1.64-1.64a6 6 0 0 1-1.676-3.257l-.172-1.03Z"
//             clip-rule="evenodd"
//           />
//         </svg>

//         <p className="text-[14px] select-none">
//           naayatrade.com Site:
//           International-India-UK-london-Europe-Italiano-Turk-Nederlands-Indonesia
//         </p>
//       </div>
//       <div className="flex gap-x-2 mt-[18px]">
//         <button className="hover:text-[#FF6300]">
//           <div className="text-[14px]">Browse Alphabetically Onetouch</div>
//         </button>
//         <div className="text-[14px] select-none">|</div>
//         <button className="hover:text-[#FF6300]">
//           <div className="text-[14px]">Showroom</div>
//         </button>
//         <div className="text-[14px] select-none">|</div>
//         <button className="hover:text-[#FF6300]">
//           <div className="text-[14px]">Country Search</div>
//         </button>
//         <div className="text-[14px] select-none">|</div>
//         <button className="hover:text-[#FF6300]">
//           <div className="text-[14px]">Suppliers</div>
//         </button>
//         <div className="text-[14px] select-none">|</div>
//         <button className="hover:text-[#FF6300]">
//           <div className="text-[14px]">Affiliate</div>
//         </button>
//       </div>
//       <div className="flex gap-x-2 mt-[18px]">
//         <button className="hover:text-[#FF6300]">
//           <div className="text-[14px]">Product Listing Policy</div>
//         </button>
//         <div className="text-[14px] select-none">|</div>
//         <button className="hover:text-[#FF6300]">
//           <div className="text-[14px]">Intellectual Property Protection</div>
//         </button>
//         <div className="text-[14px] select-none">|</div>
//         <button className="hover:text-[#FF6300]">
//           <div className="text-[14px]">Privacy Policy</div>
//         </button>
//         <div className="text-[14px] select-none">|</div>
//         <button className="hover:text-[#FF6300]">
//           <div className="text-[14px]">Terms of Use</div>
//         </button>
//         <div className="text-[14px] select-none">|</div>
//         <button className="hover:text-[#FF6300]">
//           <div className="text-[14px]">
//             User Information Legal Enquiry Guide
//           </div>
//         </button>
//       </div>
//       <p className="text-[14px] mt-[18px] select-none ">
//         2019-2024 naayatrade.com. All rights reserved
//       </p>
//     </div>
//   );
// };

// export default Footer;

import React from "react";
import { SmFooterGlobe, LgFooterGlobe } from "../../../assets/svg/allSvg";

const Footer = () => {
  const customerService = [
    "Help Center",
    "Report abuse",
    "File a case",
    "Policies & rules",
    "Get paid for your feedback",
  ];

  const aboutUs = ["About Naayatrade", "Naayatrade Blog"];

  const source = [
    "Resources",
    "All categories",
    "Request for Quotation",
    "Ready to Ship",
    "Buyer partners",
  ];

  const sellOnNaaya = [
    "Supplier memberships",
    "Learning Center",
    "Partner Program",
  ];

  const tradeServices = [
    "Trade Assurance",
    "Business identity",
    "Logistics services",
    "Production Monitoring & Inspection",
    "Services",
    "Letter of Credit",
  ];

  const socialIcons = [
    {
      url: "https://www.facebook.com/people/Naayatrade/61550488497068/?mibextid=ZbWKwL",
      imgSrc: require("../../../assets/homepage/footer/socialIcons/facebook.png"),
      alt: "Facebook",
    },
    {
      url: "https://www.instagram.com/NAAYATRADE/",
      imgSrc: require("../../../assets/homepage/footer/socialIcons/instagram.png"),
      alt: "Instagram",
    },
    {
      url: "https://www.linkedin.com/company/naaya-business-venture-pvt-ltd/mycompany/",
      imgSrc: require("../../../assets/homepage/footer/socialIcons/linkedin.png"),
      alt: "LinkedIn",
    },
    {
      url: "https://www.youtube.com/channel/UCCnjN2CmQdGVFFzwCdE7XiQ",
      imgSrc: require("../../../assets/homepage/footer/socialIcons/youtube.png"),
      alt: "YouTube",
    },
    {
      url: "https://x.com/naayatrade?s=09",
      imgSrc: require("../../../assets/homepage/footer/socialIcons/twitter.png"),
      alt: "Twitter",
    },
  ];

  return (
    <div className="flex flex-col items-center bg-[#3A475B] text-white w-full p-[16px] sm:p-10 md:p-[16px] lg:px-[100px] lg:pt-[15px] lg:pb-[80px]">
      <img
        src={require("../../../assets/homepage/footer/naayaLogo.png")}
        className="w-[103px] h-[36px] md:w-[102px] md:h-[36px] lg:w-[202px] lg:h-[71px] lg:mb-[20px] mb-[21px] md:mb-[21px]"
        alt="Naaya Logo"
      />
      <h2 className="text-center text-[14px] sm:text-[16px] font-medium mb-[21px] sm:mb-6 w-full h-[42px] max-w-[720px] md:w-[700px] md:h-[20px] md:font-medium md:text-[14px] md:mb-[21px] lg:w-[698px] lg:h-[16px] lg:font-medium lg:text-[16px] lg:mb-[20px]">
        Trade Alert-Delivery the latest product trends and industry news
        straight to your inbox.
      </h2>
      <div className="flex flex-col sm:flex-row items-center sm:gap-x-6 lg:gap-x-[20px] mb-4 w-[300px] md:w-full max-w-[720px] md:items-center md:justify-center md:mb-[21px] lg:mb-[19px]">
        <input
          placeholder="Your email"
          className="bg-inherit border-2 md:border w-[300px] h-[40px] sm:w-[16rem] px-2 py-2 mb-[20px] md:mb-0 md:w-[300px] md:h-[40px]"
        />
        <button className="bg-[#FF6300] px-4 py-2 border-[1px] font-medium text-[14px] w-[116px] h-[40px] md:w-[116px] md:h-[40px] md:font-medium md:text-[14px]">
          Subscribe
        </button>
      </div>
      <p className="text-[12px] font-medium opacity-50 text-center mb-[26px] md:mb-[36px] lg:mb-[24px] md:font-medium md:text-[12px] text-[#ADB1B9]">
        We never share your email address with a third-party
      </p>

      <div className="hidden md:grid md:grid-cols-3 lg:grid-cols-5 gap-4 lg:gap-x-[55px] md:gap-[36px] lg:gap-0 w-full max-w-[1241px] md:px-[39px] lg:px-0">
        <div className="flex flex-col items-start">
          <h2 className="text-[16px] sm:text-[18px] font-semibold mb-2 md:text-[16px] md:font-semibold lg:text-[18px]">
            Customer services
          </h2>
          {customerService.map((item, index) => (
            <div
              key={index}
              className="text-[12px] sm:text-[14px] mt-2 cursor-pointer hover:text-[#FF6300] md:text-[14px]"
            >
              {item}
            </div>
          ))}
        </div>
        <div className="flex flex-col items-start">
          <h2 className="text-[16px] sm:text-[18px] font-semibold mb-2 md:text-[16px] md:font-semibold lg:text-[18px]">
            About Us
          </h2>
          {aboutUs.map((item, index) => (
            <div
              key={index}
              className="text-[12px] sm:text-[14px] mt-2 cursor-pointer hover:text-[#FF6300]"
            >
              {item}
            </div>
          ))}
        </div>
        <div className="flex flex-col items-start">
          <h2 className="text-[16px] sm:text-[18px] font-semibold mb-2 md:text-[16px] md:font-semibold lg:text-[18px] lg:w-[207px]">
            Source on Naayatrade
          </h2>
          {source.map((item, index) => (
            <div
              key={index}
              className="text-[12px] sm:text-[14px] mt-2 cursor-pointer hover:text-[#FF6300]"
            >
              {item}
            </div>
          ))}
        </div>
        <div className="flex flex-col items-start">
          <h2 className="text-[16px] sm:text-[18px] font-semibold mb-2 md:text-[16px] md:font-semibold lg:text-[18px] lg:w-[220px]">
            Sell on naayatrade.com
          </h2>
          {sellOnNaaya.map((item, index) => (
            <div
              key={index}
              className="text-[12px] sm:text-[14px] mt-2 cursor-pointer hover:text-[#FF6300]"
            >
              {item}
            </div>
          ))}
        </div>
        <div className="flex flex-col items-start">
          <h2 className="text-[16px] sm:text-[18px] font-semibold mb-2 md:text-[16px] md:font-semibold lg:text-[18px]">
            Trade services
          </h2>
          {tradeServices.map((item, index) => (
            <div
              key={index}
              className="text-[12px] sm:text-[14px] mt-2 cursor-pointer hover:text-[#FF6300]"
            >
              {item}
            </div>
          ))}
        </div>
      </div>

      <div className="hidden lg:block w-full max-w-[1241px] border-t border-white my-6" />

      <div className="hidden md:flex md:mt-[36px] lg:mt-0 flex-col md:flex-row justify-between w-full max-w-[1241px]">
        <div className="flex flex-col md:flex-row md:gap-x-[10px] items-center mb-4 md:mb-0">
          <h2 className="text-center md:text-left md:font-medium md:text-[16px] mb-2 md:mb-0">
            Download our app:
          </h2>
          <div className="flex gap-x-4 md:gap-x-2 items-center justify-center md:justify-start">
            <div className="flex gap-x-[10px] cursor-pointer w-[197px] h-[46px] bg-[#999999] rounded-[5px] items-center justify-center">
              <img
                className="flex items-center justify-center w-[35px] h-[35px]"
                src={require("../../../assets/homepage/footer/footerLogo/android.png")}
                alt="Android"
              />
              <a
                href="https://play.google.com/store/apps/details?id=com.naayatrade.naayatrade&pli=1"
                target="_blank"
                rel="noopener noreferrer"
                className="w-[110px] h-[36px] font-semibold text-[16px] text-white text-start leading-[18px]"
              >
                Available on Google Play
              </a>
            </div>
          </div>
        </div>
        <div className="flex items-center gap-x-4 md:gap-x-2">
          <h2 className="text-center md:text-left md:font-medium">
            Follow us:
          </h2>
          <div className="flex gap-x-4 md:gap-x-[4px]">
            {socialIcons.map((icon, index) => (
              <a
                key={index}
                href={icon.url}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center justify-center"
              >
                <img
                  src={icon.imgSrc}
                  alt={icon.alt}
                  className="h-[25px] w-[25px]"
                />
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="text-center md:mt-[35px]">
        <div className="flex flex-row justify-center md:flex md:items-center md:justify-center md:gap-x-[3px]">
          <div className="block md:hidden h-[20px] md:h-0 mt-[8px] md:mt-0">
            {SmFooterGlobe}
          </div>

          <div className="hidden md:block">{LgFooterGlobe}</div>
          <p className="text-[12px] w-[289px] h-[90px] lg:w-[700px] leading-[30px] md:leading-[20px] md:w-full sm:text-[14px] md:mb-0 md:text-[14px] md:h-[22px]">
            naayatrade.com Site:
            International-India-UK-london-Europe-Italiano-Turk=Nederlands-Indonesia{" "}
          </p>
        </div>
        <div className="flex flex-wrap justify-center gap-x-2 gap-y-2 md:mt-[5px] lg:mt-[10px] lg:w-[848px]">
          {[
            "Browse Alphabetically Onetouch",
            "Showroom",
            "Country Search",
            "Suppliers",
            "Affiliate",
            "Product Listing Policy",
            "Intellectual Property Protection",
            "Privacy Policy",
            "Terms of Use",
            "User Information Legal Enquiry Guide",
          ].map((item, index) => (
            <React.Fragment key={index}>
              {index > 0 && <span>|</span>}
              <span className="text-[12px] sm:text-[14px] cursor-pointer hover:text-[#FF6300] md:text-[14px]">
                {item}
              </span>
            </React.Fragment>
          ))}
        </div>
      </div>
      {/* <p className="text-[12px] sm:text-[14px] mt-4 opacity-50">
        © 1999-2024 naayatrade.com. All rights reserved.
      </p> */}
    </div>
  );
};

export default Footer;
